import { Component, OnInit } from '@angular/core';
import { SettingService } from '../../../../../common/services/Setting.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-setting-market-survey',
  templateUrl: './setting-market-survey.component.html',
  styleUrls: ['./setting-market-survey.component.css'],
  providers: [SettingService]
})
export class SettingMarketSurveyComponent implements OnInit {

  public gpsRequired: boolean = false;
  public locationScanCustomization: boolean = true;

  constructor(
    private settingService: SettingService,
    private toastr: ToastrService,
    private translate: TranslateService,
  ) {
  }

  ngOnInit() {
    this.getMarketSurveyConfig();
    // this.checkLocationScanCustomization();
  }

  // checkLocationScanCustomization() {
  //   try {
  //     const userStr = localStorage.getItem('User');
  //     if (userStr) {
  //       const user = JSON.parse(userStr);
  //       this.locationScanCustomization = !user.location_scan_customization;
  //     }
  //   } catch (error) {
  //     console.error('Lỗi khi đọc thông tin User từ localStorage', error);
  //     this.locationScanCustomization = true;
  //   }
  // }

  getMarketSurveyConfig() {
    this.settingService.getMarketSurveyConfig().subscribe((res) => {
      if (res && res.data) {
        this.gpsRequired = res.data.locationScanMarketInspection || false;
        this.locationScanCustomization = !res.data.locationScanCustomization;
      }
    }, (error) => {
      this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    });
  }

  changeGpsRequired(event: any) {
    this.gpsRequired = event.target.checked;
    const body = {
      locationScanMarketInspection: this.gpsRequired
    };
    this.settingService.updateMarketSurveyConfig(body).subscribe((res) => {
      if (res.code === 1) {
        this.toastr.success(
          this.translate.instant('CAP_NHAT_CAU_HINH_KIEM_TRA_THI_TRUONG_THANH_CONG'),
          this.translate.instant('THONG_BAO'),
          { timeOut: 4000, positionClass: 'toast-top-right' }
        );
      }
    }, (err: any) => {
      this.gpsRequired = !this.gpsRequired;
      this.toastr.error(
        err.message || this.translate.instant('CO_LOI_XAY_RA'),
        this.translate.instant('THONG_BAO'),
        { timeOut: 4000, positionClass: 'toast-top-right' }
      );
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/setting-market-survey/setting-market-survey.component.ts